import React, { useEffect } from 'react';
import CustomPagination from 'src/components/CustomPagination/CustomPagination';
import { useClientPagination } from 'src/components/CustomPagination/useClientPagination';
import { IServiceRequest } from 'src/services/api/ServiceRequestDashboard/apiContracts';
import ConfirmationRow, {
  ConfirmationSectionVariant,
} from 'src/pages/ServiceRequests/components/ServiceRequestVisibilityDialogue/StepVisibilityConfirmation/ConfirmationRow/ConfirmationRow';
import './confirmation-section.scss';

export type { ConfirmationSectionVariant };

const SECTION_ITEMS_PER_PAGE: number = 10;

export interface ConfirmationSectionProps {
  variant: ConfirmationSectionVariant;
  heading: string;
  serviceRequests: IServiceRequest[];
}

const ConfirmationSection = ({
  variant,
  heading,
  serviceRequests,
}: ConfirmationSectionProps) => {
  const count: number = serviceRequests.length;

  const {
    currentPage,
    totalPages,
    paginatedItems,
    setCurrentPage,
    resetToFirstPage,
  } = useClientPagination<IServiceRequest>({
    items: serviceRequests,
    itemsPerPage: SECTION_ITEMS_PER_PAGE,
  });

  useEffect(() => {
    resetToFirstPage();
  }, [count]);

  if (count === 0) {
    return null;
  }

  const sectionClassName: string = `svc-section svc-section-${variant}`;
  const showPagination: boolean = totalPages > 1;

  return (
    <div className={sectionClassName}>
      <div className="svc-section-header">
        <span className="svc-section-heading">{heading}</span>
        <span className="svc-section-count">{count}</span>
      </div>
      <div className="svc-section-list">
        {paginatedItems.map((sr: IServiceRequest) => (
          <ConfirmationRow key={sr.id} serviceRequest={sr} variant={variant} />
        ))}
      </div>
      {showPagination && (
        <div className="svc-section-pagination">
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
};

export default ConfirmationSection;